<template>
  <div>
    <section>
      <div class="inner row5">
        <div class="title mobileCenter">
          <h1
            v-if="
              getUser.roleName == 'ROLE_CORP' || getUser.roleName == 'ROLE_USER'
            "
          >
            1:1 문의
          </h1>
          <h1 v-else>1:1 문의 관리</h1>
        </div>
        <section>
          <div class="row4">
            <div class="mobileReversePosition">
              <div class="topContent flex">
                <div class="mobileBlock totalCount">
                  <p>
                    총 <span class="colorRed">{{ totalCnt }}</span
                    >건
                  </p>
                </div>
                <div class="left flex mobileReset">
                  <p>
                    총 <span>{{ totalCnt }}</span
                    >건
                  </p>
                  <p>현재 페이지 {{ currentPage }} / {{ totalPage }}</p>
                </div>
                <div
                  v-if="
                    getUser.roleName == 'ROLE_CORP' ||
                      getUser.roleName == 'ROLE_USER'
                  "
                >
                  <form action="">
                    <input
                      type="button"
                      value="1:1 문의하기"
                      class="searchResetBtn searchBtnCmmn"
                      @click="onClickGo()"
                    />
                  </form>
                </div>
                <div v-else>
                  <Search />
                </div>
              </div>
              <div
                class="noticeBox"
                v-if="
                  getUser.roleName == 'ROLE_CORP' ||
                    getUser.roleName == 'ROLE_USER'
                "
              >
                <div class="borderBox qnaMobileContents">
                  <p>
                    문의내용을 작성해주세요. <br />
                    자세한 내용을 함께 보내주시면 더욱 신속히 답변드릴수
                    있습니다.
                  </p>
                </div>
              </div>
            </div>
            <div class="qnaMobileTable">
              <Board ref="board" />
            </div>
          </div>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
import Board from "@/components/layout/board/QnaList";
import Search from "@/components/layout/board/Search";
import { mapGetters, mapState } from "vuex";

export default {
  name: "QNA",
  components: {
    Board,
    Search,
  },
  computed: {
    ...mapGetters("auth", ["getUser"]),
    ...mapState("board", ["perPage", "currentPage", "totalCnt"]),
    totalPage() {
      let totalCnt = this.$store.state.board.totalCnt;
      let perPage = this.$store.state.board.perPage;

      if (totalCnt == 0) return 1;
      else if (totalCnt % perPage == 0) return totalCnt / perPage;
      else return Math.floor(totalCnt / perPage) + 1;
    },
  },
  data() {
    return {
      fields: [
        {
          key: "ROWNUM",
          label: "NO.",
          sortable: false,
        },
        {
          key: "TITLE",
          label: "제목",
          sortable: false,
        },
        {
          key: "NAME",
          label: "작성자",
          sortable: false,
        },
        {
          key: "REGDATE",
          label: "등록일",
          sortable: false,
        },
        {
          key: "ANS_STATE",
          label: "문의상태",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    onRowClicked(/*item, index, event*/) {
      this.$router.push("/qNADetail");
    },
    onClickGo: function() {
      this.$router.push("/QnAWrite");
    },
    setQna() {
      let boarObj = {
        getListURL: "/api/qna/getQnaList",
        currentPage: 1,
        perPage: 10,
        sortBy: "IDX",
        sortDesc: false,
        searchText: "",
        routerName: "qnaDetail",
        url: "/QnA",
        fields: this.fields,
      };

      this.$store.dispatch("board/setBoardSetting", boarObj);
    },
  },
  created() {
    this.setQna();
  },
};
</script>

<style scoped lang="scss">
.sampleTemplate ::v-deep {
  @import "~bootstrap/dist/css/bootstrap.min";
}
</style>
